import React from "react";
import classes from "./styles/style.module.css";
import ScoreHeaderImg from "../../../assets/images/joftPooch/awardsIcon.svg";
import ScoresList from "./ScoresList";
import { motion } from "framer-motion";

function ScoresContainer() {
  return (
    <div className={classes.scoresContainer}>
      <motion.div
        variants={{
          hidden: { opacity: 0, y: -30 },
          visible: { opacity: 1, y: 0 },
        }}
        initial="hidden"
        animate="visible"
        transition={{
          duration: 0.5,
          delay: 0.1,
        }}
      >
        <img src={ScoreHeaderImg} alt="score-banner" />
      </motion.div>
      <ScoresList />
    </div>
  );
}

export default ScoresContainer;
